import React, { useState, useRef, useEffect } from 'react';
import { flow } from 'lodash-es';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { stripHTML, transformNewlines } from 'client/site-modules/shared/utils/strip-html';
import { replaceNullChars } from 'client/site-modules/shared/utils/string';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import './seller-fees-disclaimer.scss';

export const SellerFeesDisclaimer = ({ disclaimer, className = undefined }) => {
  const [isOverflow, setOverflow] = useState(false);
  const ref = useRef();

  useEffect(() => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
        action_cause: TrackingConstant.PAGE_LOAD_CAUSE,
        action_name: TrackingConstant.ACTION_SHOW_CONTENT,
        subaction_name: TrackingConstant.SUBACTION_DISPLAY_FEE_DISCLAIMER,
        value: disclaimer,
      },
    });

    const { scrollHeight, clientHeight } = ref.current;

    if (scrollHeight > clientHeight) {
      setOverflow(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sanitizedDisclaimer = flow(replaceNullChars, stripHTML, transformNewlines)(disclaimer);
  const text = `Dealer note: ${sanitizedDisclaimer}`;

  return (
    <div
      className={classNames('seller-fees-disclaimer bg-cool-gray-90 small pos-r rounded-8', className, {
        overflow: isOverflow,
      })}
      ref={ref}
      style={{ maxHeight: '65px', overflowY: 'auto' }}
    >
      <ContentFragment inlineStyle={{ padding: '8px' }}>{text}</ContentFragment>
    </div>
  );
};

SellerFeesDisclaimer.propTypes = {
  disclaimer: PropTypes.string.isRequired,
  className: PropTypes.string,
};
